import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAuth } from "firebase/auth";
import {
  doc,
  getDoc,
  setDoc,
  collection,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { firestore } from "../../firebase";
import Modal from "react-modal";
import { v4 as uuidv4 } from "uuid";
import Stripe from "stripe";
import EditAbout from "./editLocationComponents/about";
import EditMenu from "./editLocationComponents/menu";
import EditReviews from "./editLocationComponents/reviews";
import { useLanguage } from "../../LanguageContext";
import * as text from "../../translation.json";
import { normalizeLang } from "./utils/tagTranslation";
import { buildTagsLang } from "./utils/buildTagsLang";
import { translateBatch } from "./utils/translateBatch";

const stripe = Stripe(
  "sk_test_51OC6QGF698POdFrNomZgR5tNBvaWTSnrpzevHl1YXKIBfiB5qaU79YeV2GuCBBKZgdhKZdWapxKqqfa2l0ATsPlf00FW6qVCHg",
);

const auth = getAuth();
const db = firestore;
const storage = getStorage();

const EditMyLocation = ({ currentBusinessID }) => {
  const { language } = useLanguage();
  const [regularOpeningHours, setRegularOpeningHours] = useState({
    mon: null,
    tue: null,
    wed: null,
    thu: null,
    fri: null,
    sat: null,
    sun: null,
  });
  const [regularClosingHours, setRegularClosingHours] = useState({
    mon: null,
    tue: null,
    wed: null,
    thu: null,
    fri: null,
    sat: null,
    sun: null,
  });
  const [newCustomOpeningHours, setNewCustomOpeningHours] = useState({
    date: null,
    open: null,
    close: null,
  });
  const [locationInformation, setLocationinformation] = useState(null);
  const [selectedEditMenu, setSelectedEditMenu] = useState("about");
  const [openSaveChangesModal, setOpenSaveChangesModal] = useState(false);
  const [openCancelChangesModal, setOpenCancelChangesModal] = useState(false);
  const [openActivateModal, setOpenActivateModal] = useState(false);
  const [newProfileImage, setNewProfileImage] = useState("");
  const [businessOwner, setBusinessOwner] = useState(false);
  const [textInformation, setTextInformation] = useState({
    name: "",
    tags: [],
    adress: "",
    description: "",
    websiteLink: "",
    bookingLink: "",
    phoneLink: "",
    tags_enUS: [],
    description_enUS: "",
    locationTags: [],
    locationTags_enUS: [],
    menusChanged: null,
    allergiesSubstitutes: "",
    allergiesSubstitutes_enUS: "",
  });
  const [fileImage, setFileImage] = useState({
    file1: "",
    file2: "",
    file3: "",
    file4: "",
  });
  const [fileName, setFileName] = useState({
    file1: "",
    file2: "",
    file3: "",
    file4: "",
  });
  const [menuList, setMenuList] = useState([]);
  const [oldMenuList, setOldMenuList] = useState([]);
  const [newMenu, setNewMenu] = useState(false);
  const [menuListEnglish, setMenuListEnglish] = useState([]);
  const [newMenuEnglish, setNewMenuEnglish] = useState(false);
  const [googleBusinessDetails, setGoogleBusinessDetails] = useState(null);
  const [tripadvisorLink, setTripadvisorLink] = useState("");
  const [yelpLink, setYelpLink] = useState("");
  const [newProfileFile, setNewProfileFile] = useState(null);
  const [newProfileImagePreview, setNewProfileImagePreview] = useState("");
  const [savedChanges, setSavedChanges] = useState(false);
  const [editLanguage, setEditLanguage] = useState("norwegian");
  const [userInformation, setUserInfomation] = useState(null);
  let { edit } = useParams();
  const navigate = useNavigate();
  const [irrOpeninghours, setIrrOpeningHours] = useState(false);
  const [irrOpeninghoursText, setIrrOpeninghoursText] = useState("");
  const [business, setBusiness] = useState(null);
  const [userMenus, setUserLocations] = useState([]);
  const [locationsInfo, setLocationsInfo] = useState([]);
  const [menuFetchSelectors, setMenuFetchSelectors] = useState({});
  const [menuFetchUrl, setMenuFetchUrl] = useState("");
  const [menuFetchUrlEnglish, setMenuFetchUrlEnglish] = useState("");
  const [menuFetchUrlType, setMenuFetchUrlType] = useState("");
  const [config, setConfig] = useState({
    category_container: "",
    category_name: "",
    product_item: "",
    title: "",
    description: "",
    price: "",
    allergens: "",
  });
  const [menuFetchAvailable, setMenuFetchAvailable] = useState(false);
  const [ignoreTerms, setIgnoreTerms] = useState("");
  const [includeTerms, setIncludeTerms] = useState("");
  const [suggestedTags, setSuggestedTags] = useState([]);
  // Legg irropningstider til textInformation

  const type = {
    restaurant: "Restaurant",
    activity: "Aktivitet",
    event: "Arrangement",
  };

  useEffect(() => {
    document.title = "Rediger lokasjon";
    auth.onAuthStateChanged(async function (user) {
      if (user) {
        const userDoc = doc(db, "users", user.uid);

        const userInfo = await getDoc(userDoc);
        setUserInfomation(userInfo.data());
      }
    });
  }, [auth]);

  useEffect(() => {
    const getLocationInformation = async () => {
      const getLocation = doc(db, "lokasjoner", edit);
      const regularOpeningHoursRef = collection(
        db,
        "lokasjoner",
        edit,
        "regularOpeningHours",
      );
      const locationInfo = await getDoc(getLocation);
      console.log("Getting location info:", locationInfo.data());

      if (locationInfo.data().owner === currentBusinessID) {
        setBusinessOwner(true);
      }

      const querySnapshot = await getDocs(regularOpeningHoursRef);
      const regularOpeningHoursOpeningArray = {};
      const regularOpeningHoursClosingArray = {};

      let locationtags = "";
      if (locationInfo.data().tags) {
        locationInfo.data().tags.forEach((item, index) => {
          if (index < locationInfo.data().tags.length - 1) {
            locationtags += item + ", ";
          } else {
            locationtags += item; // Do not add comma and space after the last element
          }
        });
      }

      setIrrOpeningHours(
        locationInfo.data().irregularHoursBoolean
          ? locationInfo.data().irregularHoursBoolean
          : false,
      );
      setIrrOpeninghoursText(
        locationInfo.data().irregularHoursText
          ? locationInfo.data().irregularHoursText
          : "",
      );

      setTextInformation((prevState) => ({
        ...prevState,
        name: locationInfo.data().locationName,
        tags: locationInfo.data().tags ? locationInfo.data().tags : [],
        tags_enUS: locationInfo.data().tagsLang
          ? locationInfo.data().tagsLang.en_US
            ? locationInfo.data().tagsLang.en_US
            : []
          : [],
        description_enUS: locationInfo.data().aboutBusinessLang
          ? locationInfo.data().aboutBusinessLang.en_US
            ? locationInfo.data().aboutBusinessLang.en_US
            : ""
          : "",
        adress: locationInfo.data().adress ? locationInfo.data().adress : "",
        description: locationInfo.data().aboutBusiness
          ? locationInfo.data().aboutBusiness
          : "",
        websiteLink: locationInfo.data().website
          ? locationInfo.data().website
          : "",
        bookingLink: locationInfo.data().bookingLink
          ? locationInfo.data().bookingLink
          : "",
        phoneLink: locationInfo.data().phoneNumber
          ? locationInfo.data().phoneNumber
          : "",
        locationTags: locationInfo.data().locationTags
          ? locationInfo.data().locationTags
          : [],
        locationTags_enUS: locationInfo.data().locationTagsLang
          ? locationInfo.data().locationTagsLang.en_US
            ? locationInfo.data().locationTagsLang.en_US
            : []
          : [],
        allergiesSubstitutes: locationInfo.data().allergiesSubstitutes
          ? locationInfo.data().allergiesSubstitutes.text
          : "",
        allergiesSubstitutes_enUS: locationInfo.data().allergiesSubstitutesLang
          ? locationInfo.data().allergiesSubstitutesLang.en_US
            ? locationInfo.data().allergiesSubstitutesLang.en_US.text
            : ""
          : "",
        menusChanged: locationInfo.data().menusChanged
          ? locationInfo.data().menusChanged
          : null,
        lang: locationInfo.data().lang ? locationInfo.data().lang : "nb_NO",
        currency: locationInfo.data().currency
          ? locationInfo.data().currency
          : "nok",
      }));
      setYelpLink(locationInfo.data().yelpLink);
      setTripadvisorLink(locationInfo.data().tripadvisorLink);
      if (locationInfo.data().googleNumReviews) {
        setGoogleBusinessDetails({
          user_ratings_total: locationInfo.data().googleNumReviews,
          rating: locationInfo.data().googleRating,
          place_id: locationInfo.data().googleId,
          url: locationInfo.data().googleLink,
        });
      }
      setMenuList(locationInfo.data().menus);
      setOldMenuList(locationInfo.data().menus);
      setMenuListEnglish(
        locationInfo.data().menuListLang
          ? locationInfo.data().menuListLang.en_US
            ? locationInfo.data().menuListLang.en_US
            : []
          : [],
      );
      setNewProfileImage(locationInfo.data().mainProfileImage);
      setIncludeTerms(locationInfo.data().includeTerms || "");
      setIgnoreTerms(locationInfo.data().ignoreTerms || "");
      setMenuFetchUrl(locationInfo.data().menuFetchUrl || "");
      setMenuFetchAvailable(locationInfo.data().menuFetchAvailable || false);
      setMenuFetchUrlType(
        locationInfo.data().menuFetchUrlType
          ? locationInfo.data().menuFetchUrlType
          : "",
      );

      querySnapshot.forEach((doc) => {
        const docData = doc.data();
        regularOpeningHoursOpeningArray[doc.id] = docData.open;
        regularOpeningHoursClosingArray[doc.id] = docData.close;
      });

      if (
        locationInfo.data().regularOpeningHours &&
        Object.entries(locationInfo.data().regularOpeningHours) !== undefined &&
        Object.entries(locationInfo.data().regularOpeningHours) !== null
      ) {
        Object.entries(locationInfo.data().regularOpeningHours).forEach(
          (value) => {
            regularOpeningHoursOpeningArray[value[0]] = value[1].open;
            regularOpeningHoursClosingArray[value[0]] = value[1].close;
          },
        );
      }

      setRegularOpeningHours(regularOpeningHoursOpeningArray);
      setRegularClosingHours(regularOpeningHoursClosingArray);

      setLocationinformation(locationInfo.data());
      // set images:
      if (locationInfo.data().profileImages) {
        locationInfo.data().profileImages.forEach((x, index) => {
          const fileName = `file${index + 1}`; // This will create "file1", "file2", etc.
          setFileImage((prevData) => ({
            ...prevData,
            [fileName]: x, // Dynamically assign the property name and value
          }));
        });
      }
    };
    getLocationInformation();
  }, [currentBusinessID]);

  async function getMainProfileImageUrl({
    newProfileImage,
    newProfileFile,
    existingImage,
  }) {
    // Case 1: new file uploaded
    if (newProfileImage !== existingImage && newProfileFile) {
      const uniqueKey = uuidv4();
      const storageRef = ref(getStorage(), `images/${uniqueKey}`);

      const snapshot = await uploadBytes(storageRef, newProfileFile);
      const downloadURL = await getDownloadURL(snapshot.ref);

      return downloadURL;
    }

    // Case 2: existing image string
    if (typeof newProfileImage === "string" && newProfileImage.length > 0) {
      return newProfileImage;
    }

    // Case 3: nothing
    return undefined;
  }

  const onSaveChanges = async () => {
    let averagePrice = 0;
    let totalPrice = 0;
    let numItems = 0;
    let overAllRating = 0;
    let ratingCount = 0;
    const ratingPromises = [];

    // Object.keys(menuList).forEach((element) => {
    //   totalPrice += menuList[element].prices.reduce((a, b) => a + b, 0);
    //   numItems += menuList[element].prices.length;
    // });
    menuList.forEach((category) => {
      category.prices.forEach((price, index) => {
        if (typeof price === "number" && !isNaN(price)) {
          totalPrice += price;
          numItems += 1;
        } else {
          const variants = category.variants?.[index]; // variants is now an object
          if (Array.isArray(variants)) {
            variants.forEach((variant) => {
              if (
                variant &&
                typeof variant.price === "number" &&
                !isNaN(variant.price)
              ) {
                totalPrice += variant.price;
                numItems += 1;
              }
            });
          }
        }
      });
    });

    averagePrice = numItems > 0 ? totalPrice / numItems : 0;

    if (
      fileImage.file1.length > 0 ||
      fileImage.file2.length > 0 ||
      fileImage.file3.length > 0 ||
      fileImage.file4.length > 0 ||
      locationInformation.profileImages !== undefined
    ) {
      let profileImages = ["", "", "", ""];
      if (locationInformation.profileImages !== undefined) {
        profileImages = locationInformation.profileImages;
      }

      const uploadPromises = profileImages.map(async (x, index) => {
        const file = `file${index + 1}`;

        // **Handle Image Deletion**
        if (fileImage[file] === "" && profileImages[index] !== "") {
          profileImages[index] = ""; // Remove image URL
          return { index, downloadURL: "" }; // Store deletion
        }

        // **Handle New Upload**
        if (fileImage[file] !== x && fileName[file] instanceof File) {
          const uniqueKey = uuidv4();
          const storageRef = ref(storage, `images/${uniqueKey}`);

          try {
            const snapshot = await uploadBytes(storageRef, fileName[file]);
            console.log("Uploaded a blob or file!");

            const downloadURL = await getDownloadURL(snapshot.ref);
            console.log("File available at", downloadURL);

            return { index, downloadURL };
          } catch (error) {
            console.error("Upload error:", error);
            return null;
          }
        }
        return null;
      });

      Promise.all(uploadPromises).then((results) => {
        const successfulUploads = results.filter((result) => result !== null);

        if (successfulUploads.length > 0) {
          successfulUploads.forEach(({ index, downloadURL }) => {
            profileImages[index] = downloadURL; // Update Firestore array
          });

          const collectionRef = doc(db, "lokasjoner", edit);
          updateDoc(collectionRef, { profileImages })
            .then(() => {
              console.log("Document successfully updated!");
            })
            .catch((error) => {
              console.error("Error updating document: ", error);
            });
        } else if (Object.keys(fileImage).length > 0) {
          const collectionRef = doc(db, "lokasjoner", edit);
          let newProfileImageArray = [];
          Object.keys(fileImage).forEach((key) => {
            newProfileImageArray.push(fileImage[key]);
          });
          updateDoc(collectionRef, { profileImages: newProfileImageArray })
            .then(() => {
              console.log("Document successfully updated!");
            })
            .catch((error) => {
              console.error("Error updating document: ", error);
            });
        }
      });
    }

    // Save Tripadvisor
    if (tripadvisorLink && typeof tripadvisorLink === "string") {
      const match = tripadvisorLink.match(/-d(\d+)-/);

      if (match) {
        const id = match[1];
        await fetch(
          `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/${id}`,
        )
          .then((res) => res.json())
          .then((data) => {
            // businessDetailsData
            // reviewData
            // Update last tripadvisorUpdateDate
            // Update businessDetailsData.rating
            // Save new collection for reviews with the last 5
            // + todays date
            console.log(data);

            const uniqueKey = uuidv4();
            const docRef = doc(db, "lokasjoner", edit);

            // Reference the subcollection
            const subcollectionRef = collection(docRef, "tripAdvisorRatings");
            const dayDocumentRef = doc(subcollectionRef, uniqueKey);

            updateDoc(docRef, {
              tripadvisorRating: parseFloat(data.businessDetailsData.rating),
              tripadvisorLastUpdate: new Date(),
              tripadvisorId: id,
              tripadvisorNumReviews: parseFloat(
                data.businessDetailsData.num_reviews,
              ),
              tripadvisorLink: tripadvisorLink,
              tripadvisorRatingImageLink:
                data.businessDetailsData.rating_image_url,
            });
            const r = parseFloat(data.businessDetailsData.rating);
            if (!isNaN(r)) {
              overAllRating += r;
              ratingCount++;
            }
            setDoc(dayDocumentRef, {
              reviews: data.reviewData.data,
              date: new Date(),
            })
              .then(() => {
                console.log(`${uniqueKey} hours successfully updated!`);
              })
              .catch((error) => {
                console.error(`Error updating ${uniqueKey} hours:`, error);
              });
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        console.log("ID not found in the URL.");
      }
    } else {
      console.log("tripadvisorLink is not a valid string.");
    }

    // // Save Yelp
    var baseUrl = "https://www.yelp.com/biz/";
    if (yelpLink && typeof yelpLink === "string") {
      var filteredUrl = yelpLink.replace(baseUrl, "");

      await fetch(
        `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/yelpDetails/${filteredUrl}`,
      )
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          const uniqueKey = uuidv4();
          const docRef = doc(db, "lokasjoner", edit);

          // Reference the subcollection
          const subcollectionRef = collection(docRef, "yelpRatings");
          const dayDocumentRef = doc(subcollectionRef, uniqueKey);

          updateDoc(docRef, {
            yelpRating: parseFloat(data.businessDetailsData.rating),
            yelpLastUpdate: new Date(),
            yelpId: data.businessDetailsData.id,
            yelpLink: yelpLink,
            yelpNumReviews: data.businessDetailsData.review_count,
          });
          const r = parseFloat(data.businessDetailsData.rating);
          if (!isNaN(r)) {
            overAllRating += r;
            ratingCount++;
          }
          setDoc(dayDocumentRef, {
            reviews: data.reviewData.reviews,
            date: new Date(),
          })
            .then(() => {
              console.log(`${uniqueKey} hours successfully updated!`);
            })
            .catch((error) => {
              console.error(`Error updating ${uniqueKey} hours:`, error);
            });
        });
    } else {
      console.log("yelp is not a valid string.");
      // Håndtering når tripadvisorLink ikke er en gyldig streng
    }

    // Save regular openinghours

    if (
      regularOpeningHours.mon !== null ||
      regularOpeningHours.tue !== null ||
      regularOpeningHours.wed !== null ||
      regularOpeningHours.thu !== null ||
      regularOpeningHours.fri !== null ||
      regularOpeningHours.sat !== null ||
      regularOpeningHours.sun !== null
    ) {
      const parentDocRef = doc(db, "lokasjoner", edit);

      // Build the opening hours object
      const openingHoursObject = {};

      for (const dayOfWeek in regularOpeningHours) {
        if (Object.hasOwnProperty.call(regularOpeningHours, dayOfWeek)) {
          const openingHour = regularOpeningHours[dayOfWeek];
          const closingHour = regularClosingHours[dayOfWeek];

          openingHoursObject[dayOfWeek] = {
            open: openingHour,
            close: closingHour,
          };
        }
      }

      // Update the parent document with the entire opening hours object
      setDoc(
        parentDocRef,
        { regularOpeningHours: openingHoursObject },
        { merge: true },
      )
        .then(() => {
          console.log("Regular opening hours successfully updated!");
        })
        .catch((error) => {
          console.error("Error updating opening hours:", error);
        });
    }

    console.log(googleBusinessDetails);

    if (
      (googleBusinessDetails !== null &&
        googleBusinessDetails.rating !== undefined) ||
      null
    ) {
      const r = parseFloat(googleBusinessDetails?.rating);
      if (!isNaN(r)) {
        overAllRating += r;
        ratingCount++;
      }
    }

    const bookingAvailable =
      textInformation.bookingLink.length > 0 ||
      textInformation.phoneLink.length > 0
        ? true
        : false;

    console.log(menuList);
    console.log(menuListEnglish);

    if (ratingCount > 0) {
      overAllRating = overAllRating / ratingCount;
    }

    // Clamp max
    overAllRating = Math.min(5, overAllRating);

    // Round to 1 decimal
    overAllRating = Math.round(overAllRating * 10) / 10;

    const lang_language = normalizeLang(textInformation.lang) || "nb_NO";
    const tagListTags = textInformation.tags || [];

    const aboutBusiness = textInformation.description || "";
    const toReview = locationInformation.toReview || false;
    const aboutReserve = locationInformation.type === "restaurant"
      ? "Reserver bord på telefon eller på nettsiden vår!"
      : "Bestill billetter på telefon eller på nettsiden vår!";
    const googleNumReviews = googleBusinessDetails?.user_ratings_total || 0;
    const googleRating = googleBusinessDetails?.rating || 0;
    const googleId = googleBusinessDetails?.place_id || "";
    const googleLink = googleBusinessDetails?.url || "";
    const lang = textInformation.lang ? textInformation.lang : "nb_NO";
    const currency = textInformation.currency
      ? textInformation.currency
      : "nok";
    const locationName = textInformation.name || "";
    const aboutBusinessLang = {
      en_US: textInformation.description_enUS || "",
      [lang]: textInformation.description || "",
    };
    const menuListLang = {
      en_US: menuListEnglish || [],
      [lang]: menuList,
    };
    const locationTagsLang = await buildTagsLang({
      tagList: textInformation.locationTags || [],
      fromLang: lang,
      translate: translateBatch,
      existing: { en_US: textInformation.locationTags_enUS },
    });
    const menus = menuList || [];
    const phoneNumber =
      textInformation.phoneLink !== undefined ? textInformation.phoneLink : "";
    const tags = textInformation.tags || [];
    const tagsLang = await buildTagsLang({
      tagList: tagListTags,
      fromLang: lang_language,
      translate: translateBatch,
      existing: {
        en_US: textInformation.tags_enUS,   // det brukeren faktisk har sett/redigert
      },
    });
    const website =
      textInformation.websiteLink !== undefined
        ? textInformation.websiteLink
        : "";
    const bookingLink =
      textInformation.bookingLink !== undefined
        ? textInformation.bookingLink
        : "";
    const adress =
      textInformation.adress !== undefined ? textInformation.adress : "";
    const locationTags = textInformation.locationTags || [];
    const menusChanged =
      JSON.stringify(menus) === JSON.stringify(oldMenuList)
        ? textInformation.menusChanged
        : new Date().getTime();
    const irregularHoursBoolean = irrOpeninghours ? irrOpeninghours : false;
    const irregularHoursText = irrOpeninghoursText;
    const allergiesSubstitutes =
      textInformation.allergiesSubstitutes.length > 0
        ? { text: textInformation.allergiesSubstitutes, publisher: "Eier" }
        : null;
    const allergiesSubstitutesLang =
      textInformation.allergiesSubstitutes.length > 0
        ? {
            [lang]: {
              text: textInformation.allergiesSubstitutes,
              publisher: "Eier",
            },
            en_US: {
              text: textInformation.allergiesSubstitutes_enUS,
              publisher: "Owner",
            },
          }
        : null;

    const mapping =
      menuFetchUrlType === "api" || menuFetchUrlType === "multipleApi"
        ? {
            categoriesPath: "$" + config.category_container + "[*]",
            categoryNamePath: "$" + config.category_name,
            itemsPath: "$" + config.product_item + "[*]",
            item: {
              namePath: "$" + config.title,
              descriptionPath: "$" + config.description,
              pricePath: "$" + config.price,
              allergensPath: "$" + config.allergens,
            },
          }
        : {};

    const upLoadedMenuFetchUrl = menuFetchUrl;
    const upLoadedMenuFetchUrlEnglish =
      menuFetchUrlType !== "multipleApi" ? menuFetchUrlEnglish : "";
    const upLoadedMenuFetchSelectors = menuFetchAvailable
      ? menuFetchUrlType === "selector"
        ? config
        : {}
      : {};

    const apiMapping = menuFetchAvailable
      ? menuFetchUrlType === "api" || menuFetchUrlType === "multipleApi"
        ? mapping
        : {}
      : {};

    const multipleApiMappingidObjects =
      menuFetchAvailable && menuFetchUrlType === "multipleApi"
        ? ignoreTerms
        : "";

    const multipleApiURL = menuFetchAvailable
      ? menuFetchUrlType === "multipleApi"
        ? menuFetchUrlEnglish
        : ""
      : "";

    const ignoreTermsArray = ignoreTerms
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

    const includeTermsArray = includeTerms
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);

    // const menuFetchUrlType = menuFetchUrlType;

    console.log("aboutBusiness:", aboutBusiness);
    console.log("aboutReserve:", aboutReserve);
    console.log("averagePrice:", averagePrice);
    console.log("googleNumReviews:", googleNumReviews);
    console.log("googleRating:", googleRating);
    console.log("googleId:", googleId);
    console.log("googleLink:", googleLink);
    console.log("overAllRating:", overAllRating);
    console.log("lang:", lang);
    console.log("currency:", currency);
    console.log("locationName:", locationName);
    console.log("aboutBusinessLang:", aboutBusinessLang);
    console.log("menuListLang:", menuListLang);
    console.log("locationTagsLang:", locationTagsLang);
    console.log("menus:", menus);
    console.log("phoneNumber:", phoneNumber);
    console.log("tags:", tags);
    console.log("tagsLang:", tagsLang);
    console.log("website:", website);
    console.log("bookingLink:", bookingLink);
    console.log("adress:", adress);
    console.log("bookingAvailable:", bookingAvailable);
    console.log("locationTags:", locationTags);
    console.log("ignoreTerms:", ignoreTermsArray);
    console.log("includeTerms:", includeTermsArray);

    // Updating the rest of the fields
    const dbCollection = doc(db, "lokasjoner", edit);
    const dbCollectionList = doc(db, "lokasjoner_list", edit);
    const dbCollectionMap = doc(db, "lokasjoner_map", edit);

    const resolvedMainProfileImage = await getMainProfileImageUrl({
      newProfileImage,
      newProfileFile,
      existingImage: locationInformation.mainProfileImage,
    });

    if (resolvedMainProfileImage) {
      await updateDoc(dbCollection, {
        mainProfileImage: resolvedMainProfileImage,
      });
    }

    await updateDoc(dbCollection, {
      aboutBusiness,
      aboutReserve,
      averagePrice,
      googleNumReviews,
      googleRating,
      googleId,
      googleLink,
      overAllRating,
      lang,
      currency,
      locationName,
      aboutBusinessLang,
      menuListLang,
      locationTagsLang,
      menus,
      menusChanged,
      phoneNumber,
      tags,
      tagsLang,
      website,
      bookingLink,
      adress,
      bookingAvailable,
      locationTags,
      toReview,
      irregularHoursBoolean,
      irregularHoursText,
      allergiesSubstitutes,
      allergiesSubstitutesLang,
      menuFetchSelectors: upLoadedMenuFetchSelectors,
      menuFetchUrl: upLoadedMenuFetchUrl,
      menuFetchAvailable: menuFetchAvailable,
      menuFetchUrlEnglish: upLoadedMenuFetchUrlEnglish,
      menuFetchUrlType,
      apiMapping: apiMapping,
      multipleApiMappingidObjects: multipleApiMappingidObjects,
      multipleApiURL: multipleApiURL,
      ignoreTerms,
      includeTerms,
      includeTermsArray,
      ignoreTermsArray,
    })
      .then((docRef) => {
        console.log("Document written with ID: ", docRef.id);
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });

    await setDoc(dbCollectionMap, {
      active: locationInformation.active,
      locationName,
      ...(locationInformation.slug && { slug: locationInformation.slug }),
      lat: locationInformation.lat,
      lng: locationInformation.lng,
      secondaryType: locationInformation.secondaryType
        ? locationInformation.secondaryType
        : "",
      type: locationInformation.type,
      tags,
      tagsLang,
    })
      .then((docRef) => {
        console.log("Document map written with ID: ", docRef.id);
      })
      .catch((error) => {
        console.error("Error adding documentmap: ", error);
      });

    await setDoc(dbCollectionList, {
      aboutBusinessLang,
      active: locationInformation.active,
      averagePrice,
      currency,
      g: locationInformation.g ? locationInformation.g : "",
      lat: locationInformation.lat,
      lng: locationInformation.lng,
      lang: locationInformation.lang,
      locationName,
      locationTagsLang,
      ...(resolvedMainProfileImage && {
        mainProfileImage: resolvedMainProfileImage,
      }),
      mapImage: locationInformation.mapImage
        ? locationInformation.mapImage
        : "",
      regularOpeningHours: locationInformation.regularOpeningHours,
      overAllRating,
      ...(locationInformation.slug && { slug: locationInformation.slug }),
      type: locationInformation.type,
      secondaryType: locationInformation.secondaryType
        ? locationInformation.secondaryType
        : "",
      tags,
      tagsLang,
    })
      .then((docRef) => {
        console.log("Documentlist written with ID: ", docRef.id);
      })
      .catch((error) => {
        console.error("Error adding documentlist: ", error);
      });

    setSavedChanges(true);
  };

  const onActivateLocation = async () => {
    const dbCollection = doc(db, "lokasjoner", edit);
    const dbCollectionList = doc(db, "lokasjoner_list", edit);
    const dbCollectionMap = doc(db, "lokasjoner_map", edit);
    const businessCollection = doc(db, "businesses", currentBusinessID);
    const businessInformation = await getDoc(businessCollection);
    const stripeID = businessInformation.data().stripeID;
    const activeSub = businessInformation.data().activeSub;

    if (activeSub) {
      const subscription = await stripe.subscriptions.list({
        customer: stripeID,
        status: "active", // You can specify status as 'active', 'past_due', etc.
      });

      if (subscription.data[0] !== undefined) {
        const numActive = subscription.data[0].quantity;
        const updateSubscription = await stripe.subscriptions.update(
          subscription.data[0].id,
          {
            quantity: numActive + 1,
          },
        );
      }
      updateDoc(dbCollection, {
        activeSub: true,
      });
    }

    await updateDoc(dbCollection, {
      active: true,
    });
    updateDoc(dbCollectionMap, { active: true }).catch(() => {});
    updateDoc(dbCollectionList, { active: true }).catch(() => {});
    setLocationinformation({ ...locationInformation, active: true });
    setOpenActivateModal(false);
  };

  const onDeactivateLocation = async () => {
    const dbCollection = doc(db, "lokasjoner", edit);
    const dbCollectionList = doc(db, "lokasjoner_list", edit);
    const dbCollectionMap = doc(db, "lokasjoner_map", edit);
    const businessCollection = doc(db, "businesses", currentBusinessID);
    const businessInformation = await getDoc(businessCollection);
    const stripeID = businessInformation.data().stripeID;
    const activeSub = businessInformation.data().activeSub;

    if (activeSub) {
      const subscription = await stripe.subscriptions.list({
        customer: stripeID,
        status: "active", // You can specify status as 'active', 'past_due', etc.
      });

      if (subscription.data[0] !== undefined) {
        const numActive = subscription.data[0].quantity;
        const updateSubscription = await stripe.subscriptions.update(
          subscription.data[0].id,
          {
            quantity: numActive - 1,
          },
        );
      }
    }

    updateDoc(dbCollection, {
      active: false,
    });
    updateDoc(dbCollectionMap, { active: false }).catch(() => {});
    updateDoc(dbCollectionList, { active: false }).catch(() => {});
    setLocationinformation({ ...locationInformation, active: false });
    setOpenActivateModal(false);
  };

  useEffect(() => {
    console.log(currentBusinessID);

    const effectFunction = async () => {
      const userInfo = doc(db, "businesses", currentBusinessID);
      const userLocationList = await getDoc(userInfo);

      setUserLocations(userLocationList.data().menus);
      setBusiness(userLocationList.data());

      //   if (
      //     userLocationList.data().menus !== undefined &&
      //     userLocationList.data().menus.length > 0
      //   ) {
      //     fetchData(userLocationList.data().menus);
      //   }
    };

    // Example of a basic format check, e.g., checking if the ID is a non-empty string
    const isValidID =
      currentBusinessID &&
      typeof currentBusinessID === "string" &&
      currentBusinessID.length > 0;

    if (isValidID) {
      effectFunction();
    } else {
      console.log("Invalid business ID. Please check the ID or sign in.");
    }
  }, [currentBusinessID]);

  const fetchData = async () => {
    const listData = userMenus; // Replace with your actual list of IDs
    const fetchedData = await Promise.all(
      listData.map(async (value) => {
        const docRef = doc(db, "lokasjoner", value);
        const docSnapshot = await getDoc(docRef);
        return docSnapshot;
      }),
    );

    setLocationsInfo(fetchedData);
  };

  return locationInformation !== null ? (
    !(businessOwner || userInformation?.admin) ? (
      <>Access Denied!</>
    ) : (
      <>
        <div className='editLocationPage'>
          <h1>
            {text[language].edit}{" "}
            <label className='locationNameText'>
              {locationInformation.locationName}
            </label>
            {userInformation.moderator && (
              <a
                href={`https://www.google.com/search?q=${encodeURIComponent(
                  locationInformation.locationName,
                )}`}
                target='_blank'
                rel='noopener noreferrer'>
                ↗️
              </a>
            )}
          </h1>
          <div className='aboutLocationEditting'>
            <label>Location adress</label>
            <label>
              {text[language].typeoflocation}:{" "}
              <label
                style={{
                  color:
                    locationInformation.type === "restaurant"
                      ? "#5d3160"
                      : locationInformation.type === "activity"
                        ? "#52c78c"
                        : "#4550e2",
                }}>
                {type[locationInformation.type]}
              </label>
            </label>
          </div>
          {!userInformation?.studentOrganisasjon && (
            <div>
              <label
                style={{
                  color: locationInformation.active ? "#52c78c" : "#f9615b",
                  fontWeight: "500",
                }}>
                {locationInformation.active
                  ? text[language].active
                  : text[language].notactive}
              </label>
              <button
                className='universalButton'
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setOpenActivateModal(true);
                }}>
                {locationInformation.active
                  ? text[language].deactivate
                  : text[language].activate}
              </button>
            </div>
          )}
          {userInformation.moderator ? (
            <div>
              <label
                style={{
                  color: locationInformation.toReview ? "#52c78c" : "#f9615b",
                  fontWeight: "500",
                }}>
                {locationInformation.toReview
                  ? text[language].inreview
                  : text[language].notinreview}
              </label>
              <button
                className='universalButton'
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setLocationinformation({
                    ...locationInformation,
                    toReview: !locationInformation.toReview,
                  });
                }}>
                {locationInformation.toReview
                  ? text[language].notinreview
                  : text[language].settTilreview}
              </button>
            </div>
          ) : (
            <></>
          )}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <button
                onClick={() => {
                  setSelectedEditMenu("about");
                }}
                className='editMenuButtons'
                style={
                  selectedEditMenu === "about"
                    ? {
                        color: "#f9615b",
                        backgroundColor: "white",
                        border: "white",
                      }
                    : {}
                }>
                {text[language].om}
              </button>
              <button
                onClick={() => {
                  setSelectedEditMenu("menu");
                }}
                className='editMenuButtons'
                style={
                  selectedEditMenu === "menu"
                    ? {
                        color: "#f9615b",
                        backgroundColor: "white",
                        border: "white",
                      }
                    : {}
                }>
                {locationInformation.type === "restaurant"
                  ? text[language].meny
                  : text[language].Activities}
              </button>
              {editLanguage !== "english" ? (
                <button
                  onClick={() => {
                    setSelectedEditMenu("reviews");
                  }}
                  className='editMenuButtons'
                  style={
                    selectedEditMenu === "reviews"
                      ? {
                          color: "#f9615b",
                          backgroundColor: "white",
                          border: "white",
                        }
                      : {}
                  }>
                  {text[language].omtaler}
                </button>
              ) : (
                <></>
              )}
            </div>
            <div>
              <button
                onClick={() => {
                  if (editLanguage !== "english") {
                    setEditLanguage("english");
                  } else {
                    setEditLanguage("norwegian");
                  }
                }}
                className='editMenuButtons'
                style={
                  editLanguage === "english"
                    ? {
                        color: "#f9615b",
                        backgroundColor: "white",
                        border: "white",
                      }
                    : {}
                }>
                {text[language].engelsk}
              </button>
            </div>
          </div>
          <div
            className='box'
            style={{
              borderTopLeftRadius: 0,
              padding: 25,
              paddingRight: 35,
              marginBottom: "50px",
            }}>
            {selectedEditMenu === "about" ? (
              <EditAbout
                regularOpeningHours={regularOpeningHours}
                setRegularOpeningHours={setRegularOpeningHours}
                setRegularClosingHours={setRegularClosingHours}
                regularClosingHours={regularClosingHours}
                newCustomOpeningHours={newCustomOpeningHours}
                setNewCustomOpeningHours={setNewCustomOpeningHours}
                locationInfo={locationInformation}
                newProfileImage={newProfileImage}
                setNewProfileImage={setNewProfileImage}
                fileImage={fileImage}
                setFileImage={setFileImage}
                fileName={fileName}
                setFileName={setFileName}
                textInformation={textInformation}
                setTextInformation={setTextInformation}
                newProfileFile={newProfileFile}
                setNewProfileFile={setNewProfileFile}
                newProfileImagePreview={newProfileImagePreview}
                setNewProfileImagePreview={setNewProfileImagePreview}
                editLanguage={editLanguage}
                irrOpeninghours={irrOpeninghours}
                setIrrOpeningHours={setIrrOpeningHours}
                irrOpeninghoursText={irrOpeninghoursText}
                setIrrOpeninghoursText={setIrrOpeninghoursText}
                userInformation={userInformation}
                suggestedTags={suggestedTags}
                setSuggestedTags={setSuggestedTags}
              />
            ) : selectedEditMenu === "menu" ? (
              <EditMenu
                locationId={edit}
                locationInfo={locationInformation}
                newMenu={newMenu}
                setNewMenu={setNewMenu}
                newMenuEnglish={newMenuEnglish}
                setNewMenuEnglish={setNewMenuEnglish}
                lokasjonstype={locationInformation.type}
                menuList={menuList}
                setMenuList={setMenuList}
                menuListEnglish={menuListEnglish}
                setMenuListEnglish={setMenuListEnglish}
                editLanguage={editLanguage}
                textInformation={textInformation}
                setTextInformation={setTextInformation}
                menuFetchUrl={menuFetchUrl}
                setMenuFetchUrl={setMenuFetchUrl}
                menuFetchSelectors={menuFetchSelectors}
                setMenuFetchSelectors={setMenuFetchSelectors}
                menuFetchAvailable={menuFetchAvailable}
                setMenuFetchAvailable={setMenuFetchAvailable}
                menuFetchUrlEnglish={menuFetchUrlEnglish}
                setMenuFetchUrlEnglish={setMenuFetchUrlEnglish}
                config={config}
                setConfig={setConfig}
                ignoreTerms={ignoreTerms}
                setIgnoreTerms={setIgnoreTerms}
                includeTerms={includeTerms}
                setIncludeTerms={setIncludeTerms}
                menuFetchUrlType={menuFetchUrlType}
                setMenuFetchUrlType={setMenuFetchUrlType}
                suggestedTags={suggestedTags}
                setSuggestedTags={setSuggestedTags}
              />
            ) : (
              <EditReviews
                locationInfo={locationInformation}
                googleBusinessDetails={googleBusinessDetails}
                setGoogleBusinessDetails={setGoogleBusinessDetails}
                tripadvisorLink={tripadvisorLink}
                setTripadvisorLink={setTripadvisorLink}
                yelpLink={yelpLink}
                setYelpLink={setYelpLink}
              />
            )}
            {newMenu ? (
              <></>
            ) : (
              <>
                <button
                  onClick={() => {
                    setOpenSaveChangesModal(true);
                  }}
                  className='universalButtonRed'
                  style={{
                    width: "150px",
                    marginTop: "25px",
                    marginRight: "10px",
                  }}>
                  {text[language].savechanges}
                </button>
                <button
                  onClick={() => {
                    setOpenCancelChangesModal(true);
                  }}
                  className='universalButton'>
                  {text[language].cancel}
                </button>
              </>
            )}
          </div>
        </div>
        <Modal
          isOpen={openActivateModal}
          onRequestClose={() => {
            setOpenActivateModal(false);
          }}
          className='modalStyle'
          style={{
            content: {
              width: "17%",
            },
          }}>
          {locationInformation.active ? (
            <div className='editActiveModal'>
              <label className='editPageLabel'>
                {text[language].sureDeactivate}
              </label>
              <div className='editActiveModalButtonContainer'>
                <button
                  onClick={() => {
                    onDeactivateLocation();
                  }}
                  className='universalButton'
                  style={{
                    width: "70%",
                    margin: 0,
                  }}>
                  {text[language].yesdeactivate}
                </button>
                <button
                  onClick={() => {
                    setOpenActivateModal(false);
                  }}
                  className='universalButtonRed'
                  style={{
                    width: "70%",
                    marginTop: 10,
                    marginBottom: 0,
                  }}>
                  {text[language].notakeback}
                </button>
              </div>
            </div>
          ) : (
            <div className='editActiveModal'>
              <label className='editPageLabel'>
                {text[language].sureActivate}
              </label>
              <div className='editActiveModalButtonContainer'>
                <button
                  onClick={() => {
                    onActivateLocation();
                  }}
                  className='universalButtonRed'
                  style={{
                    width: "70%",
                    margin: 0,
                  }}>
                  {text[language].yesactivate}
                </button>
                <button
                  onClick={() => {
                    setOpenActivateModal(false);
                  }}
                  className='universalButton'
                  style={{
                    width: "70%",
                    marginTop: 10,
                    marginBottom: 0,
                  }}>
                  {text[language].notakeback}
                </button>
              </div>
            </div>
          )}
        </Modal>
        {/* Save Changes Modal */}
        <Modal
          isOpen={openSaveChangesModal}
          onRequestClose={() => (
            setOpenSaveChangesModal(false),
            setSavedChanges(false)
          )}
          className='modalStyle'
          style={{
            content: {
              width: "20%",
            },
          }}>
          <div className='editActiveModal'>
            <label className='editPageLabel'>
              {text[language].saveAndPublishText}
            </label>
            <div className='editActiveModalButtonContainer'>
              <div
                style={{
                  display: savedChanges ? "block" : "none",
                  color: "#52c78c",
                  marginBottom: "5px",
                }}>
                {text[language].changesSaved}
              </div>
              <button
                onClick={onSaveChanges}
                className='universalButtonRed'
                style={{
                  width: "240px",
                  margin: 0,
                }}>
                {text[language].yespublish}
              </button>
              <button
                onClick={() => (
                  setOpenSaveChangesModal(false),
                  setSavedChanges(false)
                )}
                className='universalButton'
                style={{
                  width: "70%",
                  marginTop: 10,
                  marginBottom: 0,
                }}>
                {text[language].notakeback}
              </button>
            </div>
          </div>
        </Modal>
        {/* Cancel Changes Modal */}
        <Modal
          isOpen={openCancelChangesModal}
          onRequestClose={() => {
            setOpenCancelChangesModal(false);
          }}
          className='modalStyle'
          style={{
            content: {
              width: "20%",
            },
          }}>
          <div className='editActiveModal'>
            <label className='editPageLabel'>
              {text[language].cancelChanges}
            </label>
            <div className='editActiveModalButtonContainer'>
              <button
                onClick={() => {
                  setOpenCancelChangesModal(false);
                  navigate("/MyBusiness/myLocations");
                }}
                className='universalButton'
                style={{
                  width: "70%",
                  margin: 0,
                }}>
                {text[language].yesdeletechanges}
              </button>
              <button
                onClick={() => {
                  setOpenCancelChangesModal(false);
                }}
                className='universalButtonRed'
                style={{
                  width: "70%",
                  marginTop: 10,
                  marginBottom: 0,
                }}>
                {text[language].notakeback}
              </button>
            </div>
          </div>
        </Modal>
        {userInformation.moderator ? (
          locationsInfo.length > 0 ? (
            locationsInfo.map((lokasjonsInformasjon, rowIndex) => {
              if (lokasjonsInformasjon.id === edit) {
                return <></>; // Skip rendering the current location being edited
              }
              return (
                <div
                  key={rowIndex}
                  className='box'
                  style={{ marginBottom: "15px" }}>
                  <div className='businessOverView'>
                    <label className='locationNameLabel'>
                      {lokasjonsInformasjon.data()?.locationName}
                    </label>
                    {userInformation?.moderator ? (
                      <label
                        style={{
                          color: lokasjonsInformasjon.data()?.toReview
                            ? "#52c78c"
                            : "#f9615b",
                        }}>
                        {lokasjonsInformasjon.data()?.toReview
                          ? "I Review"
                          : "Ikke I Review"}
                      </label>
                    ) : (
                      <></>
                    )}
                    <label>
                      {lokasjonsInformasjon.data()?.adress
                        ? lokasjonsInformasjon.data()?.adress
                        : "-"}
                    </label>
                    <div>
                      <label
                        style={{
                          color: lokasjonsInformasjon.data()?.active
                            ? "#52c78c"
                            : "#f9615b",
                        }}>
                        {lokasjonsInformasjon.data()?.active
                          ? "Aktiv"
                          : "Ikke Aktiv"}
                      </label>
                      <div
                        className='universalButtonRed'
                        style={{ marginLeft: "5px", cursor: "pointer" }}
                        onClick={() => {
                          console.log(lokasjonsInformasjon.data());
                          setTextInformation({
                            ...textInformation,
                            description:
                              lokasjonsInformasjon.data().aboutBusiness || "",
                            description_enUS:
                              lokasjonsInformasjon.data().aboutBusinessLang
                                ?.en_US || "",
                            locationTags:
                              lokasjonsInformasjon.data().locationTags || [],
                            locationTags_enUS:
                              lokasjonsInformasjon.data().locationTagsLang
                                ?.en_US || [],
                            tags: lokasjonsInformasjon.data().tags || [],
                            tags_enUS:
                              lokasjonsInformasjon.data().tagsLang?.en_US || [],
                            allergiesSubstitutes:
                              lokasjonsInformasjon.data().allergiesSubstitutes
                                ?.text || "",
                            allergiesSubstitutes_enUS:
                              lokasjonsInformasjon.data()
                                .allergiesSubstitutesLang?.en_US?.text || "",
                          });
                          setNewProfileImage(
                            lokasjonsInformasjon.data().mainProfileImage || "",
                          );
                          if (lokasjonsInformasjon.data().profileImages) {
                            lokasjonsInformasjon
                              .data()
                              .profileImages.forEach((x, index) => {
                                const fileName = `file${index + 1}`; // This will create "file1", "file2", etc.
                                setFileImage((prevData) => ({
                                  ...prevData,
                                  [fileName]: x, // Dynamically assign the property name and value
                                }));
                              });
                          }
                          // setMenuList(lokasjonsInformasjon.data().menus || []);
                          // setMenuListEnglish(
                          //   lokasjonsInformasjon.data().menuListLang?.en_US ||
                          //     [],
                          // );
                        }}>
                        Copy From
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "50px",
              }}>
              <button onClick={() => fetchData()}>
                Click To Fetch Copy Menus - menu
              </button>
            </div>
          )
        ) : (
          <></>
        )}
      </>
    )
  ) : (
    <></>
  );
};

export default EditMyLocation;
